<template>
    <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>


        <!-- falta reestructurar modulo de componenteEvento -->
        <!-- <v-row v-if="componenteEvento.agregar_submodulo"> -->
        <v-row >
            <v-col class="d-flex justify-end">
                <v-btn class="btn_block_style2" dark  @click="ViewCalendar()">Ver Calendario</v-btn>
            </v-col>
        </v-row>


        <!--
                                        <v-col class="d-flex justify-end pt-0">
                                    -->
        <v-row>
            <v-col cols="12" sm="4" md="4" class="py-0">
                <v-select label="Estudiante:" v-model="filter.id_usuario_alumno" @change="eventEstudiantes(filter.id_usuario_alumno)"
                    :items="listAlumno" item-value="id_usuario_alumno" item-text="nombres_alumnos">
                </v-select>
            </v-col>


            <v-col cols="12" sm="4" md="4" class="py-0">
                <v-select label="Área:" v-model="filter.id_area" @change="eventArea(filter.id_grado, filter.id_area)"
                    :items="listArea" item-value="id" item-text="desc_area">
                </v-select>
            </v-col>


            <v-col cols="12" sm="4" md="4" class="py-0">
                <v-select label="Curso:" v-model="filter.id_curso" @change="getEvaluacionAlumno(filter)" :items="listCurso"
                    item-value="id" item-text="desc_curso">
                </v-select>
            </v-col>

            <v-col cols="12" sm="4" md="4" class="py-0">
                <v-text-field label="Buscar" v-model="search" append-icon="fa-search" single-line
                    hide-details></v-text-field>
            </v-col>

        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table :headers="headers" :items="data" :search="search" :sort-by="['nombre_template']"
                    :sort-desc="[false]" class="elevation-1 black--text" mobile-breakpoint="0">

                    <template v-slot:[`item.fecha`]="{ item }">
                        {{ item.fecha | filtroFecha }}
                </template>

                    <template v-slot:[`item.action_hora`]="{ item }">
                        {{ item.hora_inicio | filtroFormatoHora }} - {{ item.hora_fin | filtroFormatoHora }}
                    </template>

                    <template v-slot:[`item.id_estado_evaluacion`]="{ item }">
                        <v-chip small dark class="font-weight-black" :color="item.color_estado">
                            {{ item.estado_evaluacion }}
                        </v-chip>

                    </template>
    
                    <!-- <template v-slot:[`item.action_evaluar`]="{ item }">
                        <v-tooltip bottom color="#1b1b1b">
                            <template v-slot:activator="{ on }">

                                <v-btn v-if="componenteEvento.editar_submodulo" v-on="on"
                                    :disabled="item.id_estado_evaluacion != 1 || (new Date(item.fecha).toISOString().substr(0, 10) != new Date().toISOString().substr(0, 10))"
                                    @click="evaluarItem(item)" class="btn_agregar px-0 mx-0" fab x-small>
                                    <v-icon>fas fa-list-alt</v-icon>
                                </v-btn>
                            </template>
                            <span>APLICAR EVALUACIÓN {{ item.id_estado_evaluacion }} </span>
                        </v-tooltip>
                    </template> -->

                    <template v-slot:[`item.action_ver`]="{ item }">
                        <v-tooltip bottom color="#1b1b1b">
                            <template v-slot:activator="{ on }">
                                <!-- falta reeestructurar permisos de submodulos. By Kevin. -->
                                <!-- <v-btn v-if="componenteEvento.editar_submodulo" v-on="on" class="btn_ver px-0 mx-0" fab -->
                                <v-btn  v-on="on" class="btn_ver px-0 mx-0" fab
                                    x-small :disabled="item.id_estado_evaluacion != 5" @click="verItem(item)">
                                    <v-icon>fa-eye</v-icon>
                                </v-btn>
                            </template>
                            <span>VER EVALUACIÓN</span>
                        </v-tooltip>
                    </template>



                    <template v-slot:[`item.action_nota`]="{ item }">
                        <v-tooltip bottom color="#1b1b1b">
                            <template v-slot:activator="{ on }">
                                <v-chip v-if="item.tipo_calificacion == 'L' && item.id_estado_evaluacion == 5"
                                    id_estado_evaluacion color="green" v-on="on" class="texto_white" label>{{ item.literal
                                    }}</v-chip>
                                <v-chip v-else-if="item.tipo_calificacion == 'N' && item.id_estado_evaluacion == 5"
                                    color="green" v-on="on" class="texto_white" label>{{ item.nota_alumno }} {{
                                        item.tipo_calificacion }}</v-chip>
                                <v-chip v-else color="green" v-on="on" class="texto_white" label> - </v-chip>
                            </template>

                            <span>NOTA DE LA EVALUACIÓN</span>
                        </v-tooltip>
                    </template>

                </v-data-table>
            </v-col>
        </v-row>


        <span v-if="test">
            Filter: <code>{{ filter }}</code> <br>
            Datos: <code>{{ data }}</code> <br>

        </span>
        <!-- fin consulta -->
        <!-- END de modal para visualizar Imagen-->
        <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @reloadComp="reloadComp"
            @close="closeComp">
        </component>

    </div>
  </template>
  
  <script>

import axios, { API_URL } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from 'vuex';
import VisorEvaluacionComp from '@/views/Evaluacion/VisorEvaluacion/visorEvaluacion'
import CalendarioAlumnoComp from '@/views/Evaluacion/Calendario/CalendarioAlumno'
  
  export default{
    name: "evalAlumnoFamilia",
    components: {
        VisorEvaluacionComp,
        CalendarioAlumnoComp
    },
    data: () => ({
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        rutaservidor: API_URL,
        paramComponente: { "id_modulo": 7, 'id_submodulo': 97 }, //sud_modulo y modulo
        datoLogin: sessionStorage, // variables de sesion del usuario
        test: false,
        // componente General
        compName: null,
        estadoComponente: true,
        parametroComp: {},
        ////////////////////////////////////////////////////////

        // evento: 'agregar',
        search: '',
        data: [],
        filter: {},
        listAlumno: [],
        listArea: [],
        listCurso: [],

        headers: [
            { text: 'DOCENTE', value: 'profesor', class: 'secondary black--text' },
            { text: 'EVALUACIÓN', value: 'nombre_evaluacion', align: 'center', class: 'secondary black--text' },
            { text: 'FORMA', value: 'desc_forma', class: 'secondary black--text' },
            { text: 'TIPO', value: 'desc_tipo', class: 'secondary black--text' },
            { text: 'FECHA PROGRAMADA', value: 'fecha', align: 'center', class: 'secondary black--text' },
            { text: 'HORA DE INICIO', value: 'action_hora', align: 'center', class: 'secondary black--text' },
            { text: 'ESTADO', value: 'id_estado_evaluacion', align: 'center', class: 'secondary black--text' },
            // { text: 'REALIZAR', value: 'action_evaluar', sortable: false, align: 'center', class: 'secondary black--text px-0 mx-0', width: '80' },
            { text: 'VISUALIZAR', value: 'action_ver', sortable: false, align: 'center', class: 'secondary black--text px-0 mx-0', width: '80' },
            { text: 'NOTA', value: 'action_nota', sortable: false, align: 'center', class: 'secondary black--text px-0 mx-0', width: '80' }

        ],

    }),

    //computadas
    computed: {
        ...mapGetters('login', ['componenteEvento'])

    },

    mounted() {
        this.loadMain()
    },

    created() {

        this.actualizarParamentro()
    },


    methods: {
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA //////////////////////
        // -- Validar accesos por perfil ------------
        ...mapActions('login', ['parametroComponente']),
        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },

        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        ////////////////////////////////////////////////////////

        //-- cargar Parametros de inicio del componente --
        async loadMain() {
            this.limpiarForm();
            await this.getEstudiantesPorFamiliar(this.datoLogin.id);
            let arrayAlum = this.listAlumno.map(al => al.id_alumno);
            this.filter.id_alumno = arrayAlum.length ? arrayAlum : -1;
            // this.getEvaluacionAlumno(this.filter);

        },


        //-------mostrar registros------------
        async getEvaluacionAlumno(filter) {
            try {
                let response = await axios.post(`/evaluacion/alumnos/view/`, { filter })
                this.data = response.data
                if (this.data.length == 0) {
                    this.setEnviarMens({ tipo: "W", mensaje: `No se encontrarón registros`, tiempo: null })
                }
            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },


        async getEstudiantesPorFamiliar(id_usuario){
            let params = {id_usuario, id_ano_lectivo: this.datoLogin.id_ano_lectivo};

            try {

                let {data} = await axios.get("/sistema/integral/getAlumnosPorFamiliar", {
                    params
                })
                if (data.length == 0) {
                    this.setEnviarMens({ tipo: "W", mensaje: `No se encontraron estudiantes`, tiempo: null })

                } else {
                    this.listAlumno = data
                    
                }

            } catch (error) {
                console.error(error);
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }
        },


        async getUserAlumno(id_usuario) {

            let params = { id_usuario, id_ano_lectivo: this.datoLogin.id_ano_lectivo }

            try {
                let response = await axios.post(`/sistema/integral/getAlumnoAnoLectivo/`, { filter: params })
                let resp = response.data
                // console.log(`getUserDocente (evaluacion.vue) ${resp}`)
                if (resp.length == 0) {
                    this.setEnviarMens({ tipo: "W", mensaje: "No hay resultados", tiempo: null })

                } else {
                    // this.listAlumno = resp
                    this.filter.id_alumno = resp.id_alumno
                    this.filter.id_nivel = resp.id_nivel
                    this.filter.id_grado = resp.id_grado
                    this.filter.id_seccion = resp.id_seccion

                    this.getArea(this.filter.id_colegio, this.filter.id_grado)
                }

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },


        async getArea(id_colegio, id_grado) {
            let params = { id_colegio, id_grado }

            try {
                let response = await axios.post(`/sistema/integral/getAreaAdm/`, { filter: params })
                this.listArea = response.data

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },


        async getCurso(id_colegio, id_grado, id_area) {
            let params = { id_colegio, id_grado, id_area }
            try {

                let response = await axios.post(`/sistema/integral/getCurso/`, { filter: params })
                this.listCurso = response.data

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },



        async eventEstudiantes(id_usuario){
            this.filter.id_area = '';
            this.filter.id_curso = '';
            await this.getUserAlumno(id_usuario);
            await this.getEvaluacionAlumno(this.filter);
        },

        eventArea(id_grado, id_area) {
            // this.setEnviarMens({tipo:"E", mensaje: `Grado ${id_grado}`, tiempo:null})
            this.filter.id_curso = ''

            this.getCurso(this.datoLogin.id_colegio, id_grado, id_area)
            this.getEvaluacionAlumno(this.filter)
        },


        ///////////////////////////////////////////////////
        //-- Componente de Alumnos    -------- ///

        

        verItem(items) {

            console.log(` verItem()   *alumnoEval* : items: `)
            let params = {
                id_evaluacion: items.id_evaluacion,
                id_colegio: items.id_colegio,
                id_profesor: items.id_profesor,
                id_alumno: items.id_alumno,
                duracion_evaluacion: items.duracion_evaluacion
            }

            // qualifyAlumno
            let data = { evento: "qualifyAlumno", items: params }
            this.parametroComp = data
            this.compName = "VisorEvaluacionComp"
            this.estadoComponente = true

        },


        ViewCalendar() {
            //this.setEnviarMens({tipo:"W", mensaje: `Agregar Formulario`, tiempo:null})
            this.parametroComp = {
                evento: "add", id_alumno: this.filter.id_alumno,
                id_colegio: this.datoLogin.id_colegio, id_ano_lectivo: this.datoLogin.id_ano_lectivo
            }
            this.compName = "CalendarioAlumnoComp"
            this.estadoComponente = true
        },


        /*******cerrar modal y blanquear arreglos */
        closeComp() {
            console.log(`closeComp *alumnoEval*`)
            this.estadoComponente = false
            this.parametroComp = {}
            this.loadMain()
        },
        reloadComp() {
            console.log('reloadComp')
        },


        limpiarForm() {

            this.filter = {
                id_colegio: this.datoLogin.id_colegio,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                id_alumno: '',
                id_area: '',
                id_curso: '',
                id_seccion: ''
            }

            this.paramComponente = {}
            this.estadoComp = false
        },




    },
  }
  </script>
  
  <style scoped>
    .texto_white {
        font-size: 14px;
        font-weight: bold;
        color: #fff !important;

    }
    </style>